import clsx from 'clsx'
import { BardTerms as BardTermsType } from '@/src/@types/statamic'
import Picture from '@/src/components/elements/Picture'

export default function BardTerms({
  optional_title: title,
  terms,
}: BardTermsType) {
  return (
    <div>
      {title && <h3 className="mb-3 text-lg font-black">{title}</h3>}
      <dl className="grid gap-6 md:grid-cols-2">
        {terms.map((term, index) => (
          <div
            key={index}
            className={clsx('rounded-lg bg-blue-50 px-5 py-4', {
              'bg-blue-50': !term.color || term.color?.value === 'blue',
              'bg-yellow-50': term.color?.value === 'yellow',
              'bg-green-50': term.color?.value === 'green',
              'bg-red-50': term.color?.value === 'red',
            })}
          >
            <div className="flex h-12 items-center space-x-4">
              {term.icon && (
                <Picture
                  {...term.icon}
                  height={48}
                  width={48}
                  className="object-contain"
                  quality={100}
                />
              )}
              <dt className="text-lg font-bold">{term.term}</dt>
            </div>
            <dd className="mt-4">{term.description}</dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
